import { NetworkService } from './network-service';

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

const handleProjectError = (endpoint, error) => {
  console.error(`Errore durante l'operazione su ${endpoint}: `, error);
};

const handleFileError = (endpoint, error) => {
  console.error(`Errore durante l'operazione sui file in ${endpoint}: `, error);
};
export const ProjectManagementService = {
  getProject: (projectId, callback, errorCallback) => {
    const url = `${API_BASE_URL}/api/projects/${projectId}/`;
    NetworkService.get(url, callback, (error) => {
      if (errorCallback) {
        errorCallback(error);
      }
    });
  },

  getProjectFile: (fileId, callback, errorCallback) => {
    const url = `${API_BASE_URL}/api/analysis-documents/${fileId}/`;
    NetworkService.get(url, callback, (error) => {
      if (errorCallback) {
        errorCallback(error);
      }
    });
  },

  getProjectFiles: (projectId, callback, errorCallback) => {
    const url = `${API_BASE_URL}/api/analysis-documents/by_project/`;
    const queryParams = [['project_id', projectId]];
    NetworkService.get(
      url,
      callback,
      (error) => {
        handleFileError(
          `recupero dei file del progetto con ID ${projectId}`,
          error
        );
        if (errorCallback) {
          errorCallback(error);
        }
      },
      queryParams
    );
  },

  deleteProjectFile: (fileId, callback, errorCallback) => {
    const url = `${API_BASE_URL}/api/analysis-documents/${fileId}/`;
    NetworkService.delete(url, callback, (error) => {
      handleFileError(`eliminazione del file con ID ${fileId}`, error);
      if (errorCallback) {
        errorCallback(error);
      }
    });
  },

  downloadProjectFile: (fileId, callback, errorCallback) => {
    const url = `${API_BASE_URL}/api/analysis-documents/${fileId}/download/`;
    NetworkService.getBlob(url, callback, (error) => {
      if (errorCallback) {
        errorCallback(error);
      }
    });
  },

  updateProjectFileDescription: (fileId, body, callback, errorCallback) => {
    const url = `${API_BASE_URL}/api/analysis-documents/${fileId}/`;
    NetworkService.patch(url, body, callback, (error) => {
      handleFileError(
        `aggiornamento della descrizione del file con ID ${fileId}`,
        error
      );
      if (errorCallback) {
        errorCallback(error);
      }
    });
  },

  uploadProjectFile: (projectId, formData, callback, errorCallback) => {
    const url = `${API_BASE_URL}/api/analysis-documents/`;

    NetworkService.postMultiPart(url, formData, callback, (error) => {
      handleFileError(
        `caricamento del file nel progetto con ID ${projectId}`,
        error
      );
      if (errorCallback) {
        errorCallback(error);
      }
    });
  },

  updateExistingProject: (projectId, payload, callback, errorCallback) => {
    const url = `${API_BASE_URL}/api/projects/${projectId}/`;
    NetworkService.put(url, payload, callback, (error) => {
      handleProjectError(
        `aggiornamento del progetto con ID ${projectId}`,
        error
      );
      if (errorCallback) {
        errorCallback(error);
      }
    });
  },

  getAllProjects: (callback, errorCallback) => {
    const url = `${API_BASE_URL}/api/projects/`;
    NetworkService.get(
      url,
      (data) => {
        callback(data);
      },
      (error) => {
        handleProjectError('elenco dei progetti', error);
        if (errorCallback) {
          errorCallback(error);
        }
      }
    );
  },

  createProject: (projectData, callback, errorCallback) => {
    const url = `${API_BASE_URL}/api/projects/`;
    NetworkService.post(url, projectData, callback, (error) => {
      handleProjectError('creazione del progetto', error);
      if (errorCallback) {
        errorCallback(error);
      }
    });
  },

  deleteProject: (projectId, callback, errorCallback) => {
    const url = `${API_BASE_URL}/api/projects/${projectId}/`;
    NetworkService.delete(url, callback, (error) => {
      handleProjectError(
        `eliminazione del progetto con ID ${projectId}`,
        error
      );
      if (errorCallback) {
        errorCallback(error);
      }
    });
  },

  fetchMarkdownContent: (downloadUrl, token, setMarkdownContent) => {
    fetch(downloadUrl, {
      headers: {
        Authorization: `Token ${token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Errore nel recupero del file md: ${response.status}`
          );
        }
        return response.text();
      })
      .then((text) => {
        setMarkdownContent(text);
      })
      .catch((error) => {
        console.error('Errore durante il recupero del file md:', error);
      });
  },
};
